/** @format */

import { Loading, Modal, TextInput } from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import {
  fetchAllIndustries,
  bulkDeleteIndustry,
  updateIndustry,
} from "../../redux/actions/industryAction";

function IndustryPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoadingData, setIsLoadingData] = useState(true);

  const headers = [
    {
      key: "industryName",
      header: "Industry name",
    },
  ];

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    industryId: undefined,
    industryName: undefined,
  });

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      industryName: row.industryName,
    };
  };

  const updateIndustryDetail = () => {
    dispatch(
      updateIndustry(
        {
          industryId: modalContent.industryId,
          industryName: modalContent.industryName,
        },
        () => {
          // reset modal content
          setModalContent({
            modalHeading: "",
            isOpen: false,
            industryId: undefined,
            industryName: undefined,
          });

          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteIndustry(
        {
          industryIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewIndustryDetail = (_data) => {
    const industryId = _data[0].id.split(":")[0];
    const industryName = _data.filter(
      (v) => v.info.header === "industryName"
    )[0]?.value;

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${industryName}`,
      industryId,
      industryName,
    }));
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
    });
  };

  const searchTable = async (e) => {
    const { value } = e.target;

    fetch({
      query: value,
      page: 0,
      limit: paginationContent.limit,
    });
  };

  const fetch = ({ query, page, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllIndustries(
        { query, page, limit },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));

          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  return (
    <UIShell
      breadcrumbs={[{ name: "Home", link: "/" }, { name: "Industries" }]}
    >
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/industries/form")}
        viewDetail={viewIndustryDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Industry details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateIndustryDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <TextInput
          data-modal-primary-focus
          labelText="Industry Name"
          placeholder="industry name"
          value={modalContent.industryName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, industryName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    dataTableList: state.industryReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(IndustryPage);
